import React, { useEffect, useState } from 'react';
import './CookieConsent.css'; // create corresponding CSS for styling

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [preferences, setPreferences] = useState({
    essential: true,
    analytics: false
    // marketing: false
  });

  const COOKIE_STORAGE_KEY = 'cookieConsentPrefs';
  const COOKIE_EXPIRY_DAYS = 180;
  const MS_PER_DAY = 24 * 60 * 60 * 1000;

  useEffect(() => {
    const stored = getStoredConsent();
    if (!stored || isExpired(stored.timestamp)) {
      setShowBanner(true);
    } else {
      setPreferences({ ...preferences, ...stored.preferences });
      loadScripts(stored.preferences);
    }
  }, []);

  const getStoredConsent = () => {
    try {
      const data = localStorage.getItem(COOKIE_STORAGE_KEY);
      return data ? JSON.parse(data) : null;
    } catch {
      return null;
    }
  };

  const isExpired = (timestamp) =>
    Date.now() - timestamp > COOKIE_EXPIRY_DAYS * MS_PER_DAY;

  const saveConsent = (prefs) => {
    const timestamp = Date.now();
    const data = { preferences: prefs, timestamp };
    localStorage.setItem(COOKIE_STORAGE_KEY, JSON.stringify(data));
    loadScripts(prefs);
  };

  const loadScripts = (prefs) => {
    if (prefs.analytics && !window.gtag) {
      const script = document.createElement('script');
      script.src = 'https://www.googletagmanager.com/gtag/js?id=G-MCS44488GQ';
      script.async = true;
      document.head.appendChild(script);

      script.onload = () => {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          window.dataLayer.push(arguments);
        }
        window.gtag = gtag;
        gtag('js', new Date());
        gtag('config', 'G-MCS44488GQ');
      };
    }

    if (prefs.marketing) {
      console.log('Load marketing scripts...');
    }
  };

  const handleToggle = (category) => {
    if (category === 'essential') return;
    const updated = { ...preferences, [category]: !preferences[category] };
    setPreferences(updated);
  };

  const handleSave = () => {
    saveConsent(preferences);
    setShowBanner(false);
    setShowModal(false);
  };

  const handleAcceptAll = () => {
    const updated = {
      essential: true,
      analytics: true
      //   marketing: true
    };
    setPreferences(updated);
    saveConsent(updated);
    setShowBanner(false);
    setShowModal(false);
  };

  return (
    <>
      {showBanner && (
        <div className="cookie-banner">
          <div className="cookie-content">
            <div className="cookie-text">
              <strong>🍪 We value your privacy</strong>
              <br />
              We use cookies to enhance your experience, analyze site traffic,
              and serve personalized content. Essential cookies are always
              active. Analytics cookies are used only with your consent.
            </div>
            <div className="cookie-buttons">
              <button
                className="cookie-btn accept-all"
                onClick={handleAcceptAll}
              >
                Accept All
              </button>
              <button
                className="cookie-btn essential-only"
                onClick={() => handleSave()}
              >
                Essential Only
              </button>
              <button
                className="cookie-btn settings"
                onClick={() => setShowModal(true)}
              >
                Manage Preferences
              </button>
            </div>
          </div>
        </div>
      )}

      {showModal && (
        <div
          className="cookie-modal"
          onClick={(e) =>
            e.target.classList.contains('cookie-modal') && setShowModal(false)
          }
        >
          <div className="modal-content">
            <button className="modal-close" onClick={() => setShowModal(false)}>
              &times;
            </button>
            <h2>Manage Cookie Preferences</h2>
            <p>
              We use cookies to ensure you get the best experience on our
              platform. Some are essential to the website`s operation, while
              others help us improve and personalize your experience.
            </p>

            {['essential', 'analytics'].map((key) => (
              <div className="cookie-category" key={key}>
                <div className="category-header">
                  <div className="category-title">
                    {key.charAt(0).toUpperCase() + key.slice(1)} Cookies
                  </div>
                  <div
                    className={`toggle-switch ${
                      preferences[key] ? 'active' : ''
                    } ${key === 'essential' ? 'disabled' : ''}`}
                    onClick={() => handleToggle(key)}
                  >
                    <div className="toggle-slider" />
                  </div>
                </div>
                <div className="category-description">
                  {key === 'essential' &&
                    'These cookies are necessary for core functionalities like security, account login, and matchmaking operations. They cannot be turned off.'}
                  {key === 'analytics' &&
                    'These cookies help us understand how visitors interact with the site—like which pages are most visited—so we can improve user experience.'}
                  {/* {key === 'marketing' &&
                    'These cookies allow us to show personalized ads and offers tailored to your interests.'
} */}
                </div>
              </div>
            ))}

            <div className="modal-buttons">
              <button
                className="cookie-btn essential-only"
                onClick={handleSave}
              >
                Save Preferences
              </button>
              <button
                className="cookie-btn accept-all"
                onClick={handleAcceptAll}
              >
                Accept All
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CookieConsent;
// This code is a React component for a cookie consent banner with preferences.
// It allows users to accept all cookies, only essential cookies, or manage their preferences.
